const objContext = JSON.parse(sessionStorage.getItem("context"));
if (objContext == null || objContext.store_name == null)
    location.href = 'index.html';
document.querySelector('.sidebar-profile-img img').src = objContext.store_image
document.querySelector('.sidebar-profile-name-store').innerHTML = objContext.store_name.replace(/\\/, '')
const sectionTab = document.querySelectorAll('.sidebar-menu-container-section-tab');

let currentStore = localStorage.getItem('currentStore');

document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';

sectionTab[4].classList.add('sidebar-menu-container-section-tab--active');
const storeQrTemplate = `
    <div>
        <div class="qr-item" id="qr-index-__ID__">
            <figure class="qr-item--img">
                <img src="__IMG__" id="edit-qr-img-__ID__">
            </figure>
            __INPUTS__
            <h3 class="mb-1">__LOCATION__ __PLACE__ </h3>
            <div class="qr-item-actions">
                __EDIT_BUTTON__
            </div>
        </div>
    </div>`
window.addEventListener('load', loadPage)
const context = JSON.parse(sessionStorage.getItem('context'))


function printADiv(el) {
    var elementID = el.split('#')[1]

    window.print();
}


function loadPage() {
    UI.showLoader()

    fetch(BASE_URLS.Dinny.api + '/qrs?storeId=' + localStorage.getItem('currentStore') + '&req_id=1598594065091', {
        credentials: 'include'
    })
        .then(function (qrResponse) {
            document.querySelector('.profile-form-der').innerHTML = '<spam class="profile-form-title-subsection">Agregados</spam>'
            if (qrResponse.ok) {
                qrResponse.json().then(function (json) {
                    let totalQR = json.length
                    if (totalQR == 0) {
                        generateCode({
                            store_id: localStorage.getItem('currentStore'),
                            method: 'post'
                        },
                            function (response) {
                                if (response.ok) {
                                    loadPage()
                                } else {
                                    response.json().then(function (json) {
                                        UI.message({ title: 'Código QR', content: json.message, accept: 'Aceptar' })
                                        UI.hideLoader()
                                    })
                                }
                            }
                        )
                    } else {
                        for (var i = 0; i < totalQR; i++) {
                            var nameStore = `
                            Establecimiento <br>
                            ${objContext.store_name}
                        `;
                            if (json[i].place == '' && json[i].location == '') {
                                document.querySelector('.profile-form-der')
                                    .insertAdjacentHTML(
                                        'beforeend',
                                        storeQrTemplate
                                            .replace(/__LOCATION__/g, nameStore)
                                            .replace(/__PLACE__/g, json[i].place)
                                            .replace(/__INPUTS__/g, '')
                                            .replace(/__ID__/, i)
                                            .replace(/__IMG__/g, json[i].img + '?v=' + new Date()).replace(
                                                /__EDIT_BUTTON__/g,
                                                    `
                                                    <div class="wrap-action-icons">
                                                        <div class="icon-download" onclick="printQr(event)"
                                                            data-qr="${json[i].img}" data-store="${localStorage.getItem('currentStore')}">
                                                        </div>
                                                    </div>
                                                    `
                                            )
                                            .replace(/__ID__/, i)
                                    )
                            } else {
                                document.querySelector('.profile-form-der')
                                    .insertAdjacentHTML(
                                        'beforeend',
                                        storeQrTemplate
                                            .replace(/__LOCATION__/g, json[i].location)
                                            .replace(/__PLACE__/g, json[i].place)
                                            .replace(/__ID__/, i)
                                            .replace(/__INPUTS__/g, `
                                            <div id="cnt-edit-qr-location-${i}" class="form-group invisible">
                                                <label class="input-label">Ubicación</label>
                                                <input class="form-input" id="txb-edit-qr-location-${i}" type="text" placeholder="Mesa, barra, etc." value="${json[i].location}" autocomplete="new-key" required="">
                                            </div>
                                            <div id="cnt-edit-qr-place-${i}" class="form-group invisible">
                                                <label class="input-label">Lugar</label>
                                                <input class="form-input" id="txb-edit-qr-place-${i}" type="text" placeholder="1, a, etc." value="${json[i].place}" autocomplete="new-passwor" required="">
                                            </div>`
                                            )
                                            .replace(/__IMG__/g, json[i].img + '?v=' + new Date())
                                            .replace(
                                                /__EDIT_BUTTON__/g,
                                                `<a id="btn-edit-qr-${i}" class="btn btn-outline-secondary" href="#" onclick="editQR(${i})">Editar</a>
                                                <div class="wrap-action-icons">
                                                    <div class="icon-download" onclick="printQr(event)"
                                                        data-qr="${json[i].img}" data-store="${localStorage.getItem('currentStore')}">
                                                    </div>
                                                    <a class="icon-trash" href="#" onclick="deleteCode('${localStorage.getItem('currentStore')}','${json[i].img}')"></a>
                                                </div>`
                                            )
                                            .replace(/__ID__/, i)
                                    )
                            }
                        }
                        // $(".qr-container").append(addQrTemplate)
                        // addEvent()
                        // hideLoader()

                        UI.hideLoader()
                    }
                })
            } else {
                if (qrResponse.status == 403) {
                    window.location.href = 'login.html'
                } else {
                    UI.hideLoader()
                }
            }
        })

    document.getElementById('btn-add-qr').onclick = function (e) {
        e.preventDefault()
        const location = document.getElementById('txb-location').value, place = document.getElementById('txb-place').value
        generateCode({
            store_id: localStorage.getItem('currentStore'),
            location: location,
            place: place,
            method: 'post'
        }, function (response) {
            if (response.ok) {
                document.getElementById('txb-location').value = ''
                document.getElementById('txb-place').value = ''
                loadPage()
            } else {
                response.json().then(function (json) {
                    UI.message({ title: 'Código QR', content: json.message, accept: 'Aceptar' })
                    UI.hideLoader()
                })
            }
        })
    }

    document.getElementById('print-qrs').onclick = (e) => {
        e.preventDefault();
        const printableDiv = e.target.dataset.to;
        console.log(e)
        printADiv(printableDiv)
    }


}

function printQr(e){
    let containerQRCodes = document.querySelector('#formQr')
    let QRCodes = document.querySelectorAll('.qr-item')

    // Indicate to QR container that only and QR div is going to print
    containerQRCodes.classList.add('individual-print')
    // Indicate which QR div is going to print
    e.target.parentNode.parentNode.parentNode.classList.add('individual-print')
    
    // Hide all QR divs that not contains the class individual print
    QRCodes.forEach(  (element) => {
        if(!element.classList.contains('individual-print'))
            element.classList.add('hide')
    })

    // Start to print window
    window.print()
    
    // Remove the class individual print to QR div
    e.target.parentNode.parentNode.parentNode.classList.remove('individual-print')
    // Show all QR divs again
    QRCodes.forEach(  (element) => {
        element.classList.remove('hide')
    })
}

function generateCode(data, callback) {
    if ('' != data.location && '' != data.place) {
        if (/^[a-záéíóúüÁÉÍÓÚÜ\d\-_\s]+$/i.test(data.location) && /^[a-záéíóúüÁÉÍÓÚÜ\d\-_\s]+$/i.test(data.place)) {
            UI.showLoader()
            fetch(BASE_URLS.Dinny.api + '/qrs?req_id=' + new Date().getTime(),
                {
                    credentials: 'include',
                    body: JSON.stringify(data),
                    method: data.method
                }
            )
                .then(function (qrResponse) {
                    callback(qrResponse)
                })
                .catch(callback)
        } else {
            UI.message({ title: 'Código QR', content: 'Ingresaste datos incorrectos, verifícalos e intenta nuevamente.', accept: 'Aceptar' })
        }
    } else {
        UI.message({ title: 'Código QR', content: 'No has agregado información para crear un código QR.', accept: 'Aceptar' })
    }
}

function deleteCode(store_id, img) {

    UI.confirm({
        title: 'Borrar Código QR',
        content: `¿Deseas eliminar el código QR?`,
        accept: 'Aceptar',
        cancel: 'Cancelar'
    }, function (response) {
        if (response) {
            UI.showLoader()
            fetch(BASE_URLS.Dinny.api + '/qrs?img=' + img + '&store_id=' + store_id + '&req_id=' + new Date().getTime(), {
                credentials: 'include',
                method: 'delete'
            })
                .then(function (qrResponse) {
                    if (qrResponse.ok) {
                        loadPage()
                    } else {
                        UI.message({ title: 'Código QR', content: 'Ocurrió un error al eliminar el QR. Por favor, inténtalo nuevamente.', accept: 'Aceptar' })
                    }
                })
        }
    })
}

function editQR(index) {
    let btn = document.getElementById(`btn-edit-qr-${index}`)
    let place = document.getElementById(`txb-edit-qr-place-${index}`)
    let location = document.getElementById(`txb-edit-qr-location-${index}`)
    let location_cont = document.getElementById(`cnt-edit-qr-location-${index}`)
    let place_cont = document.getElementById(`cnt-edit-qr-place-${index}`)
    let img = document.getElementById(`edit-qr-img-${index}`)

    if ("editar" == btn.innerHTML.toLocaleLowerCase()) {
        location_cont.classList.remove("invisible");
        place_cont.classList.remove("invisible");
        btn.innerHTML = 'Guardar'
    } else {
        generateCode({
            img: img.src.split('?')[0],
            location: location.value,
            place: place.value,
            store_id: localStorage.getItem('currentStore'),
            method: 'put'
        },
            function (response) {
                if (response.ok) {
                    loadPage()
                } else {
                    alert.error("Ocurrió un error al generar el código QR.<br /> Por favor inténtalo nuevamente.")
                }
            }
        )
        // console.log(, , , )
    }
}
